import { messaging } from '../firebase';

export const notificationPermissions = async () => {
  try {
    if (messaging !== null) {
      await messaging.requestPermission();
    }
  } catch (err) {}
};

export const getToken = async () => {
  try {
    if (messaging !== null) {
      const currentToken = await messaging.getToken();
      return currentToken;
    }

    return null;
  } catch (err) {
    console.warn(err);
    return false;
  }
};

export const refreshToken = async (
  callback: (refreshToken: string) => void
) => {
  try {
    if (messaging !== null) {
      messaging.onTokenRefresh(() => {
        if (messaging !== null) {
          messaging
            .getToken()
            .then(callback)
            .catch((err) => {
              console.warn('Unable to retrieve refreshed token ', err);
            });
        } else {
          console.warn('No messaging object in onTokenRefresh');
        }
      });
    }

    return null;
  } catch (err) {
    console.warn(err);
    return false;
  }
};
